import { render } from "./ConfigureVasionSettings.vue?vue&type=template&id=dbf09384&scoped=true"
import script from "./ConfigureVasionSettings.vue?vue&type=script&lang=js"
export * from "./ConfigureVasionSettings.vue?vue&type=script&lang=js"

import "./ConfigureVasionSettings.vue?vue&type=style&index=0&id=dbf09384&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbf09384"]])

export default __exports__